
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Slider } from '@/components/ui/slider';
import { Textarea } from '@/components/ui/textarea';
import { toast } from '@/hooks/use-toast';

interface EmotionFormValues {
  ansiedade: number;
  estresse: number;
  calma: number;
  felicidade: number;
  notas: string;
}

const EmotionRegistrationForm = () => {
  const form = useForm<EmotionFormValues>({
    defaultValues: {
      ansiedade: 5,
      estresse: 5,
      calma: 5,
      felicidade: 5,
      notas: '',
    },
  });

  const onSubmit = (data: EmotionFormValues) => {
    console.log(data);
    // Aqui você enviaria os dados para a API
    toast({
      title: "Registro salvo",
      description: "Seu registro emocional foi salvo com sucesso!",
    });
    
    // Reset form after submission
    form.reset({
      ansiedade: 5,
      estresse: 5,
      calma: 5,
      felicidade: 5,
      notas: '',
    });
  };

  const emocoes = [
    { name: 'ansiedade', label: 'Ansiedade', description: 'Nível de preocupação ou inquietação' },
    { name: 'estresse', label: 'Estresse', description: 'Nível de pressão ou tensão' },
    { name: 'calma', label: 'Calma', description: 'Sensação de tranquilidade e serenidade' },
    { name: 'felicidade', label: 'Felicidade', description: 'Nível de contentamento e alegria' },
  ];

  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle>Registro de Emoções</CardTitle>
        <CardDescription>
          Registre como você está se sentindo neste momento
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
            {emocoes.map((emocao) => (
              <FormField
                key={emocao.name}
                control={form.control}
                name={emocao.name as keyof EmotionFormValues}
                render={({ field }) => (
                  <FormItem>
                    <FormLabel className="flex justify-between">
                      <span>{emocao.label}</span>
                      <span className="text-sm text-muted-foreground">{field.value}/10</span>
                    </FormLabel>
                    <FormControl>
                      <Slider
                        min={1}
                        max={10}
                        step={1}
                        defaultValue={[field.value as number]}
                        onValueChange={(values) => {
                          if (Array.isArray(values) && values.length > 0) {
                            // Ensure we're working with a number
                            const numericValue = Number(values[0]);
                            field.onChange(numericValue);
                          }
                        }}
                      />
                    </FormControl>
                    <FormDescription>{emocao.description}</FormDescription>
                    <FormMessage />
                  </FormItem>
                )}
              />
            ))}

            <FormField
              control={form.control}
              name="notas"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Notas</FormLabel>
                  <FormControl>
                    <Textarea
                      placeholder="Quais foram os acontecimentos do seu dia? O que está em sua mente?"
                      {...field}
                    />
                  </FormControl>
                  <FormDescription>
                    Descreva como você está se sentindo e o que está acontecendo em sua vida
                  </FormDescription>
                  <FormMessage />
                </FormItem>
              )}
            />

            <Button type="submit">Salvar registro</Button>
          </form>
        </Form>
      </CardContent>
    </Card>
  );
};

export default EmotionRegistrationForm;
